import { LazyAction, LazyImport, LazyModule } from "owa-bundling-light";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "HeaderMicrosoft365UpsellIris" */ "./lazyIndex"), { name: "HeaderMicrosoft365UpsellIris" });

export const lazyLoadOutlookHeaderM365UpsellButtonIrisContent: LazyAction<typeof lazyIndex.loadOutlookHeaderM365UpsellButtonIrisContent, typeof lazyModule> = new LazyAction(lazyModule, module => module.loadOutlookHeaderM365UpsellButtonIrisContent);

export const lazyGetOutlookHeaderM365UpsellButtonIrisContent: LazyImport<typeof lazyIndex.getOutlookHeaderM365UpsellButtonIrisContent, typeof lazyModule> = new LazyImport(lazyModule, module => module.getOutlookHeaderM365UpsellButtonIrisContent);

export type { OutlookHeaderM365UpsellButtonContent } from "./types/OutlookHeaderM365UpsellButtonContent";
